import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'zsl-btn',
  templateUrl: './zsl-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [``]
})
export class ZslBtnComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
